module.exports = __webpack_public_path__ + "img/header-logos.af285e10.png";